import { NgModule } from  '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, AdminAuthGuard } from '../services/auth.guard';
import { UserService } from '../services/user.service';
import { UserTokenComponent } from './token.component';
import { AccountComponent } from './account.component';
import { SharedModule  } from '../shared/module';

const routes: Routes = [{
  path: 'account',
  component: AccountComponent,
  children: [
    {
      path: '',
      component: AccountComponent,
      pathMatch: 'full'
    },
    {
      path: 'tokens',
      component: UserTokenComponent,
      data: { tab_name: 'tokens' },
      canActivate: [ AuthGuard ],
    },
  ]
}];


@NgModule({
  imports: [
    RouterModule.forChild(routes),
    BrowserModule,
    SharedModule,
  ],
  exports: [
    RouterModule
  ],
  declarations: [
    UserTokenComponent,
    AccountComponent,
  ],
  providers: [
    AuthGuard,
    AdminAuthGuard,
    UserService,
  ]
})

export class AccountModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/account/module.ts